import { render, staticRenderFns } from "./qarecord.vue?vue&type=template&id=63208f8e&"
import script from "./qarecord.vue?vue&type=script&lang=js&"
export * from "./qarecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports